<template>
  <div class="createInvoice">
    <div class="create_title">
      Create an invoice
    </div>
    <div>
      <el-form :model="createInvoiceForm" label-position="top" :rules="createRules" status-icon ref="admiRuleForm"
               :show-message="false">
        <el-form-item label="Organization ID" label-width="120px" required>
          <el-input v-model="createInvoiceForm.organization_number"
                    placeholder="Name"
                    autocomplete="off"
                    @blur="getOrgInfoHandle"
                    style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="Legal Company Name" label-width="120px">
          <el-input v-model="createInvoiceForm.legal_com_name"
                    placeholder=""
                    :disabled="true"
                    autocomplete="off" style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label=" Detail" label-width="120px" required>
          <div class="innerTable">
            <el-table
              :data="invoice_table_data"
              style="width: 100%">
              <el-table-column
                prop="task_date"
                label="Day & Date"
                >
              </el-table-column>
              <el-table-column
                prop="store_name"
                label="Store">
              </el-table-column>
              <el-table-column
                label="Rate">
                <template slot-scope="scope">
                 ${{scope.row.rate_per_task}}
                </template>
              </el-table-column>
              <el-table-column
                prop="total_tasks"
                label="QTY"
                width="50"
              >
              </el-table-column>
              <el-table-column
                label="Amount"
                align="right"
              >
                <template slot-scope="scope">
                  ${{scope.row.total}}
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="btom_mes" style="margin-top: 8px">
      <span style="font-weight: bold">Subtotal: </span><span>${{subtotal}}</span>
    </div>
    <div class="btom_mes">
      <span style="font-weight: bold">HST(13%): </span><span>${{hst}}</span>
    </div>
    <div class="btom_mes"><span  style="font-weight: bold">Total: </span>$<span>{{total}}</span></div>
    <div class="load_but">
      <el-button type="primary" @click="loadUnList" :class="invoice_table_data.length>0?'wight_btn':''">Load uninvoiced tasks</el-button>
    </div>
    <div style="color: #E95646;">
      All uninvoiced tasks from the start date up to the current date will be loaded.
    </div>
    <div class="footers">
      <div>
        <el-button type="success" @click="cancelCreate" class="changes">Cancel</el-button>
        <el-button @click="confirmCreate" class="changeCreate">Submit</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrgInfo, manualCreate, unInvoiceTask} from "@/api/bill";

export default {
  name: "createInvoice",
  data(){
    return{
      invoice_table_data:[],
      createInvoiceForm:{
        organization_number:"",
        legal_com_name:'',
      },
      createRules:{},
      subtotal:'0.00',
      hst:'0.00',
      total:'0.00',
    }
  },
  methods:{
    cancelCreate(){
      this.createInvoiceForm.organization_number = ''
      this.createInvoiceForm.legal_com_name = ''
      this.invoice_table_data = []
      this.subtotal='0.00'
      this.hst='0.00'
      this.total='0.00'
      this.$emit('closeCreate')
    },
    confirmCreate(){
      manualCreate({
        organization_number:this.createInvoiceForm.organization_number
      }).then(res=>{
        if (res.code == 200){
          this.cancelCreate()
          this.$message({
            type:"success",
            message:res.data
          })
        }else {
          this.$message({
            type:"warning",
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err.msg
        })
      })
    },
    getOrgInfoHandle(){
      if (this.createInvoiceForm.organization_number == ''){
        this.createInvoiceForm.legal_com_name = ''
        this.invoice_table_data = []
      }else {
        getOrgInfo({
          organization_number:this.createInvoiceForm.organization_number
        }).then(res=>{
          if (res.code == 200){
            this.createInvoiceForm.legal_com_name = res.data.legal_company_name
          }else {
            this.$message({
              type:"warning",
              message:res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type:"error",
            message:err.msg
          })
        })
      }

    },
    loadUnList(){
      if (this.createInvoiceForm.organization_number == ''){
        this.$message({
          type:'warning',
          message:"Some information missing"
        })
      }else {
        unInvoiceTask({
          organization_number:this.createInvoiceForm.organization_number
        }).then(res=>{
          if (res.code == 200){
            this.invoice_table_data = res.data.task
            this.subtotal = res.data.sub_total
            this.total = res.data.total
            this.hst = res.data.tax
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type:"error",
            message:err.msg
          })
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.createInvoice{
  padding-bottom: 90px;
  .create_title{
    font-size: 18px;
    font-weight: bold;
  }
  .innerTable{
    width: 800px;
    border-top: 1px solid #e0e0e0;
    overflow: auto;
    /deep/.el-table td.el-table__cell{
      border: none!important;
    }
    /deep/.el-table .el-table__cell{
      height: 20px;
      padding:8px 0!important;
    }
    /deep/.el-table::before{
      height: 0!important;
    }
    /deep/.el-table__footer-wrapper{
      border-bottom: 1px solid #E0E0E0;
    }

  }
  .btom_mes{
    margin: 16px 0;
  }
  .load_but{
    margin: 24px 0 16px;
    .wight_btn{
      background-color: #CCCCCC !important;
    }
  }
  .footers{
    width:calc( 100% - 72px);
    z-index: 1;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    flex-direction: row-reverse;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;
    .changeCreate{
      color: #1F2D42;
    }
    .changes{
      border: 1px solid #FFFFFF!important;
    }
    .changeCreate:focus{
      border-color: #FFFFFF;
      background-color: #FFFFFF;
    }
    .changeCreate:hover{
      border-radius: 16px;
      border: 1px solid #FFFFFF;
      background: #1F2D42;
      color: #FFFFFF;
    }
  }
}

</style>
